import {Component, inject, OnInit} from '@angular/core';
import {NgbAlert, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ModalContainerComponent} from '../modal-container/modal-container.component';

import {UserService} from '@core/services/user.service';
import {FormValidationClassDirective} from '@core/directives/form-validation-class.directive';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {FormService} from '@core/services/form.service';

@Component({
  selector: 'app-create-account-modal',
  templateUrl: './create-account-modal.component.html',
  styleUrls: ['./create-account-modal.component.scss'],
  imports: [NgbAlert, ModalContainerComponent, FormValidationClassDirective, ReactiveFormsModule]
})
export class CreateAccountModalComponent implements OnInit {
  protected userService = inject(UserService);
  private modalService = inject(NgbModal);
  private formService = inject(FormService);


  errorMessage: string|undefined = undefined;
  email: string | undefined = undefined;
  fullname: string | undefined = undefined;
  phone: string | undefined = undefined;

  createAccountForm = new FormGroup<{
    fullname: FormControl<string | null>,
    email: FormControl<string | null>,
    phone: FormControl<string | null>,
  }>({
    fullname: new FormControl('', [Validators.required, this.formService.nameValidation()]),
    email: new FormControl('', [Validators.required, Validators.email, this.formService.emailValidation()]),
    phone: new FormControl('', [Validators.required, this.formService.patternValidation('^[+0-9]{8,11}$')]),
  });

  ngOnInit() {
    if (this.email) {
      this.createAccountForm.controls.email.setValue(this.email);
    }
    if (this.phone) {
      this.createAccountForm.controls.phone.setValue(this.phone);
    }
    if (this.fullname) {
      this.createAccountForm.controls.fullname.setValue(this.fullname);
    }
  }

  isFullNameInvalid() {
    return this.createAccountForm.controls.fullname.getError('nameError') && this.createAccountForm.controls.fullname.touched
  }

  submit() {
    if (this.createAccountForm.invalid) {
      this.createAccountForm.markAllAsTouched();
      return;
    }
    this.modalService.dismissAll();
    import('../create-password-modal/create-password-modal.component').then(({CreatePasswordModalComponent}) => {
      const modalRef = this.modalService.open(CreatePasswordModalComponent);

      modalRef.componentInstance.email = this.createAccountForm.value.email;
      modalRef.componentInstance.fullname = this.createAccountForm.value.fullname;
      modalRef.componentInstance.phone = this.createAccountForm.value.phone;
      modalRef.componentInstance.isCustomerCreateFlow.set(true);
    });
  }

  goToLogin() {
    this.modalService.dismissAll();
    import('../login-modal/login-modal.component').then(({LoginModalComponent}) => {
      this.modalService.open(LoginModalComponent);
    });
  }
}
